import * as React from 'react';
import createSvgIcon from '../../utils/createSvgIcon';
/**
 * @ignore - internal component.
 */

export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), 'KeyboardArrowRight');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/internal/svg-icons/KeyboardArrowRight.js
// module id = 868
// module chunks = 2